import React, { useEffect, useState } from "react";
import { Row, Col, Input, Form } from "../../ui/ot";
import dayjs from "dayjs";
import axios from "axios";

const ClassifyStructureForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    customFormItems = () => { },
    defaultValue = {},
    propsOnValuesChange = () => { },
    field,
    fieldName = field?.name,
    formMode = false,
    propsShowKeys = [
        { key: "name", name: "name", hidden: false, require: true },
    ]
}) => {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        if (!formMode)
            propsOnValuesChange(formValues)
        //   setFormValuesOtherThings(formValues);
    };

    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    useEffect(() => {
        // setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    useEffect(() => {
        if (!formMode)
            (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        hidden={propsShowKeys?.find((element) => {
                            return element.name === "name"
                        })?.hidden}
                        rules={[
                            {
                                required: propsShowKeys?.find((element) => {
                                    return element.name === "name"
                                })?.require,
                                message: "請填寫"
                            }
                        ]}
                        label={"名稱"} name={formMode ? [field?.name ?? '', 'name'] : [fieldName ?? '', 'name']}>
                        {propsShowKeys?.find((element) => {
                            return element.name === "name"
                        })?.hidden ? undefined : <Input></Input>}
                    </Form.Item>
                    {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form, field, onFinish)}
                </Form>
            </Col>
        </Row>
    );
};

export default ClassifyStructureForm;
